import { useMutation } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { useQueryParam, StringParam } from "use-query-params";
import { showErrorToast } from "../toast/toast-service";
import { getGraphQLErrorMessage } from "../helpers/network-helpers";
import { DELETE_USER_CONFIRM } from "../apollo-client/mutations";
import { useIntl } from "react-intl";
import { useEffect } from "react";

export const DeleteAccountPage = () => {
    const intl = useIntl();
    const history = useHistory();

    const [token] = useQueryParam("token", StringParam);

    const [deleteUserConfirm] = useMutation(DELETE_USER_CONFIRM, {
        onCompleted: () => {
            localStorage.removeItem("token");
            history.push("/");
            window.location.reload();
        },
        onError: (error) => {
            showErrorToast(getGraphQLErrorMessage(error));
            history.push("/");
        },
    });

    useEffect(() => {
        if (!token) {
            showErrorToast(intl.formatMessage({ id: "edit-user-data.delete-account.confirmation.error" }));
            history.push("/");
            return null;
        }

        if (token) {
            deleteUserConfirm({ variables: { token } });
        }
    }, [token]);




  return <div>DeleteAccountPage</div>;
};
